import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import FavoriteIcon from "@mui/icons-material/Favorite";
import EmailIcon from "@mui/icons-material/Email";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import "../../css/layout/Footer.css";
import { getGoogleMapsLanguageParam } from "../../utils/language";
import siteSettings from "../../cms/site-settings.json";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const footerQuickLinks = (siteSettings.footerQuickLinks || []).map((link, index) => ({
    id: index + 1,
    title: link.title,
    link: link.link,
  }));

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-column">
          <h3>Find Us</h3>
          <div className="footer-map-container">
            <iframe
              src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3086.312096047336!2d-76.61963292441439!3d39.326513971635585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c804e061f1319f%3A0x2dbaaaa6e2714b83!2sJohns%20Hopkins%20Hillel!5e0!3m2!1sus!4v1753726112713!5m2!1sus-419!2sus&zoom=15&maptype=roadmap${getGoogleMapsLanguageParam()}`}
              allowFullScreen=""
              title="Johns Hopkins Hillel Location Map"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="footer-address-text">
            {siteSettings.addressLine1}
            <br />
            {siteSettings.addressLine2}
          </div>
        </div>

        <div className="footer-column">
          <h3>Connect With Us</h3>
          <div className="footer-social-links">
            <a
              href={siteSettings.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon />
            </a>
            <a
              href={siteSettings.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon />
            </a>
            <a
              href={siteSettings.linkedinUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedInIcon />
            </a>
            <a
              href={siteSettings.youtubeUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTubeIcon />
            </a>
          </div>
          <div className="footer-button-group">
            <a
              className="footer-donate-button"
              href={siteSettings.donateUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FavoriteIcon />
              {siteSettings.donateLabel}
            </a>
            <a
              className="footer-shop-button"
              href={siteSettings.shopUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ShoppingBagIcon />
              {siteSettings.shopLabel}
            </a>
            <a
              className="footer-mailing-list-button"
              href="/mailing-list"
              target="_blank"
              rel="noopener noreferrer"
            >
              <EmailIcon />
              {siteSettings.mailingListLabel}
            </a>
          </div>
        </div>

        <div className="footer-column footer-column-split">
          <div className="footer-sub-column">
            <h3>Contact Information</h3>
            <ul className="footer-link-list">
              <li className="footer-link-item">
                <a href={`mailto:${siteSettings.email}`}>{siteSettings.email}</a>
              </li>
              <li className="footer-link-item">
                <a href={`tel:${siteSettings.phoneTel}`}>{siteSettings.phoneDisplay}</a>
              </li>
            </ul>
          </div>
          
          <div className="footer-sub-column">
            <h3>Quick Links</h3>
            <div className="footer-quick-links">
              {footerQuickLinks.map((quickLink) => (
                <a
                  key={quickLink.id}
                  href={quickLink.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-quick-link-button"
                >
                  <span className="footer-quick-link-icon">{quickLink.icon}</span>
                  <span className="footer-quick-link-text">{quickLink.title}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="footer-agency-logos">
        <h4>{siteSettings.partnersHeading}</h4>
        <div className="footer-logo-container">
          <a
            href="https://associated.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://res.cloudinary.com/dz0ncigli/image/upload/v1755193212/associated-logo_fxlesd.jpg"
              alt="The Associated - Jewish Federation of Baltimore"
              className="footer-agency-logo footer-agency-logo--associated"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </a>
          <a
            href="https://www.hillel.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://res.cloudinary.com/dz0ncigli/image/upload/v1755550878/hillel_international_logo_diywie.png"
              alt="Hillel International"
              className="footer-agency-logo footer-agency-logo--hillel-international"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </a>
        </div>
      </div>

      <div className="footer-bottom-bar">
        <p>
          © {currentYear} {siteSettings.copyrightOrg}. All rights reserved. |{" "}
          <a href="/privacy-policy">Privacy Policy</a> |{" "}
          <a href="/terms-of-use">Terms of Use</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
